import { FEEDBACK, FEEDBACKUNFILTERED } from "../config/api-urls";
import CommonAPI from "../lib/common";
import { publicActions } from "./publicSlice";
import toast from "react-hot-toast";
import { NOTIFICATION, NOTIFICATION_STATUS, TAG_SEARCH } from "./constants";

export const toggleHamburger = (navOpen = false) => {
  return async (dispatch) => {
    dispatch(publicActions.toggleHamburger(navOpen));
    window.scrollTo(0, 0);
  };
};

export const changeTheme = (changeTo) => {
  return async (dispatch) => {
    dispatch(publicActions.changeTheme(changeTo));
  };
};

export const sendFeedback = (payload, navigate, redirect = true) => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(FEEDBACK, payload, "POST");
      toast.success("Your feedback has been successfully submitted.");
      redirect &&
        setTimeout(() => {
          navigate("/profile");
        }, 400);
      return response;
    } catch (error) {
      toast.error("Something went wrong..");
      // console.log(error);
    }
  };
};

export const getFeedbacks = () => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(FEEDBACK);
      return response;
    } catch (error) {
      toast.error("Something went wrong..");
      // console.log(error);
    }
  };
};

export const getFeedbacksUnfiltered = () => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(FEEDBACKUNFILTERED);
      return response;
    } catch (error) {
      toast.error("Something went wrong..");
      // console.log(error);
    }
  };
};

export const getNotification = (searchQuery = "") => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(`${NOTIFICATION}${searchQuery}`);
      dispatch(publicActions.getNotification({ response: response }));
      return response;
    } catch (error) {
      // console.log(error);
    }
  };
};

export const markAsRead = (uuid) => {
  return async (dispatch) => {
    try {
      const response = await CommonAPI(
        `${NOTIFICATION_STATUS}?notification_id=${uuid}`
      );
      toast.success(`Notification marked as read.`);
      return response;
    } catch (error) {
      toast.error("Something went wrong..");
      // console.log(error);
    }
  };
};
